import React, { useEffect, useRef, useState } from "react";
import Highcharts from "highcharts/highstock";
import PieChart from "highcharts-react-official";
import HighchartsReact from "highcharts-react-official";
import { Box, Grid2, List, ListItem, ListItemIcon, ListItemText, Typography, useTheme, Skeleton } from "@mui/material";
import { Circle } from "@mui/icons-material";
import { FaSquareFull } from "react-icons/fa6";
import { useParams } from "react-router-dom";
import { useGetAdvancePaymentQuery } from "store/slices/apis/paymentTrackerSlice";



const DistributionByDeduction = () => {
    const theme = useTheme();
    const { projectId } = useParams();

    const { data, isLoading, error } = useGetAdvancePaymentQuery({ projectId });



    const mainData = data?.data || {};


    const moduleColorMap = {
        'Liquidated Damage': '#E72B33',
        'Retention': '#FFBF00',
        'Work Done': '#3E756D',

    };

    const Graphdata = [
        {
            label: "Liquidated Damage",
            count: Number((mainData?.deductionRetention ?? 0).toFixed(2))
        },
        {
            label: "Retention",
            count: Number((mainData?.deductionLd ?? 0).toFixed(2))
        },
        {
            label: "Work Done",
            count: Number((mainData?.deductionWorkdone ?? 0).toFixed(2))
        }
    ]

    const totalCount = Graphdata?.reduce((sum, item) => sum + item.count, 0) || 0;

    const openIssuesData = Graphdata?.map((item, index) => ({
        y: item.count,
        name: item.label,
        value: item.count,
        color: moduleColorMap[item.label],
        percentage: (item.count / totalCount) * 100,
    })) || [];


    const options = {
        chart: {
            type: "pie",
            width: 190,
            height: 190,
            marginBottom: 10,
            marginRight: 0,
            marginLeft: 10,
            marginTop: 10,
        },
        title: {
            text: '',
            style: {
                fontWeight: 700,
                fontSize: '25px',
                color: '#000000',
                lineHeight: '100%'
            },
            align: 'center',
            verticalAlign: 'middle',
            y: 15,
        },
        subtitle: {
            useHTML: true,
            text: '',
            align: 'center',
            verticalAlign: 'middle',
            style: { "fontSize": "16px", "fontWeight": "400", "color": "#000000", "lineHeight": "100%", },
            y: 25, x: 0
        },
        credits: {
            enabled: false
        },
        tooltip: {
            formatter: function () {
                // Customize the hover text here
                return `<b style='color: ${this.color}'>${this.name}</b>: ${this.y}`;
            }
        },
        plotOptions: {
            pie: {
                allowPointSelect: false,
                borderWidth: 0,
                borderRadius: 0,
                cursor: "pointer",
                innerSize: 80,
                dataLabels: {
                    enabled: false,
                },
                showInLegend: false,

                //startAngle: -20,
                // point: {
                //   events: {
                //     click: function () {
                //       setPopupData({
                //         name: this.severityname,
                //         value: this.y,
                //       });
                //       setOpen(true);
                //     }
                //   }
                // },
            }
        },
        series: [
            {
                name: "",
                dataLabels: {
                    verticalAlign: 'top',
                    enabled: true,
                    style: {
                        fontWeight: 600,
                        fontSize: '11px',
                        color: '#FFFFFF',
                        lineHeight: '40px',
                        textOutline: 'none',
                    },
                    //style: { "fontSize": "11px", "fontWeight": "600"},
                    //connectorWidth: 1,
                    distance: -16,
                    //connectorColor: '#000000',
                    formatter: function () {
                        return Math.round(this.percentage) + '%';
                    }
                },
                color: "#006600",
                lineWidth: 1,
                marker: {
                    enabled: false,
                    symbol: "circle",
                    radius: 3,
                    states: {
                        hover: {
                            enabled: true,
                            lineWidth: 1
                        }
                    }
                },
                data: openIssuesData,
            }
        ]
    };



    if (isLoading) {
        return (
            <Box sx={{ p: 2, width: "100%", height: "251px", maxWidth: "100%", border: "1px solid #D8D8D8", mt: 0, borderRadius: "12px", overflow: "hidden", backgroundColor: "white" }}>
                <Box sx={{}}>
                    <Typography variant="body" sx={{ fontWeight: 500, fontSize: "18px", lineHeight: "100%", letterSpacing: '-0.4px', color: `${theme?.customSettings?.themeColor}`, }}>
                        Open Issues Distribution by Severity
                    </Typography>
                    <Typography sx={{ mt: "5px", color: "#5052588A", fontWeight: 500, fontSize: "14px", lineHeight: "100%", letterSpacing: '-0.4px' }}>
                        Get a holistic view of how work is being prioritized
                    </Typography>
                </Box>
                <Grid2 container>
                    <Grid2 size={{ xs: 12, md: 7 }}>
                        {[...Array(3)].map((_, index) => (
                            <Grid2 container direction="row" spacing={1} key={index} sx={{ marginLeft: "10px", paddingTop: index === 0 ? '40px' : '10px' }}>
                                <Box sx={{ width: "25px", padding: "8px" }}>
                                    <Skeleton variant="circular" width={18} height={18} />
                                </Box>
                                <Box sx={{ width: "130px", padding: "8px" }}>
                                    <Skeleton variant="text" width={100} height={20} />
                                </Box>
                                <Box sx={{ width: "30px", padding: "4px" }}>
                                    <Skeleton variant="text" width={20} height={28} />
                                </Box>
                            </Grid2>
                        ))}
                    </Grid2>

                    <Grid2 size={{ xs: 12, md: 5 }} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Skeleton variant="circular" width={120} height={120} />
                    </Grid2>
                </Grid2>
            </Box>
        );
    }

    return (
        <Box sx={{
            p: 2,
            width: "100%",
            height: "100%",
            maxWidth: "100%",
            border: "1px solid #D8D8D8",
            borderRadius: "12px",
            overflow: "hidden",
            backgroundColor: "white",
            // display: 'flex',
            // flexDirection: 'column'
        }}>
            <Box sx={{ flexShrink: 0 }}>
                <Typography variant="body" sx={{ fontWeight: 500, fontSize: "18px", lineHeight: "100%", letterSpacing: '-0.4px', color: `${theme?.customSettings?.themeColor}`, }}>
                    Distribution by Deductions (in Cr)
                </Typography>
                {/* <Typography sx={{ mt: "5px", color: "#5052588A", fontWeight: 500, fontSize: "14px", lineHeight: "100%", letterSpacing: '-0.4px' }}>
                    Get a holistic view of how work is being prioritized
                </Typography> */}
            </Box>

            <Box sx={{
                flexGrow: 1,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexDirection: { xs: "column", md: "row" },
                overflow: 'hidden',
                gap: 2,
                mt: 2
            }}>
                {openIssuesData?.length === 0 ? (
                    <Box sx={{ width: '100%', textAlign: 'center', py: 4 }}>
                        <Typography variant="body1" color="textSecondary">
                            No data available to display the chart.
                        </Typography>
                    </Box>
                ) : (
                    <>
                        <List sx={{
                            padding: 0,
                            mb: { xs: 1, md: "12px" },
                            flex: '1 1 auto',
                            overflow: 'auto',
                            maxHeight: '100%',
                            width: { xs: '100%', md: 'auto' },
                            textAlign: { xs: 'center', md: 'left' }
                        }}>
                            {openIssuesData?.map((val, index) => (
                                <ListItem key={index} sx={{ paddingLeft: 0, justifyContent: { xs: 'center', md: 'flex-start' },alignItems: { xs: 'center', md: 'baseline' }, }}>
                                    <ListItemIcon sx={{ minWidth: '20px' }}>
                                        <FaSquareFull
                                            style={{ color: `${val?.color}`, height: '14px', width: '14px' }}
                                        />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={
                                            <>
                                                <Typography component="span" sx={{ fontWeight: 500, fontSize: "16px", letterSpacing: "-0.4px" }}>
                                                    {val?.name}:{' '}
                                                </Typography>
                                                <Typography component="span" sx={{ fontWeight: 500, fontSize: "16px", color: "#182A4E" }}>
                                                    {val?.value.toFixed(2)}
                                                </Typography>
                                            </>
                                        }
                                    />
                                </ListItem>
                            ))}
                        </List>

                        <Box sx={{
                            flexShrink: 0,
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: { xs: '100%', md: 'auto' },
                            mt: { xs: 2, md: 0 }
                        }}>
                            <PieChart highcharts={Highcharts} options={options} />
                        </Box>
                    </>
                )}
            </Box>
        </Box>
    )
};

export default DistributionByDeduction;
